<template>
    <div class="newsletter-section section-space--ptb_120 default-bg" id="contact">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-10  ml-auto mr-auto">
                    <div class="section-title-wrapper text-center section-space--mb_50 wow move-up">
                        <h3 class="section-title text-white">{{ $t('sendekatil') }}</h3>
                    </div>
                    <!-- newsletter form -->
                    <div class="newsletter-form--one section-space--mb_20 text-center wow move-up">
                        <form v-on:submit="gonderMail">
                            <input type="text" name="to_name" v-model="ContactForm.name" :placeholder="$t('adiniz')">
                            <input type="email" name="reply_to" v-model="ContactForm.email" :placeholder="$t('email')">
                            <input name="subject_html" v-model="ContactForm.subject" :placeholder="$t('email')" hidden>
                            <input name="message_html" v-model="ContactForm.message" :placeholder="$t('email')" hidden>
                            <div class="clinic-button">
                            <button class="ht-btn ht-btn-md" type="submit">{{ $t('banaulasin') }}</button>
                            </div>
                        </form>
                    </div>
                    <!-- newsletter text -->
                    <h6 class="text-white text-center wow move-up">{{ $t('siradanevar') }} <a href="#" class="hover-style-link hover-style-link--green">{{ $t('dahafazla') }}</a></h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';
import xml2js from "xml2js";
import fs from "fs";
import notify from 'devextreme/ui/notify';
import { mapGetters } from "vuex";
//import soap from 'soap';
//import querystring from 'querystring';
import emailjs from 'emailjs-com';


    export default {
        name: 'newsletter',
        data() {
            return {
            name:'',
            mail:'',
            webservice_url:'https://www.barkodyazilimevi.com.tr/AuthToken.asmx',
            //data_to_send:[{'sMail':this.getFirmaResult.sMail,'sUserName':this.getFirmaResult.nFirmaID,'sPassword':this.getFirmaResult.sPostaKodu,'sBayii':this.getFirmaResult.nFirmaID}],
            msg:'',
            sFirma:'',
            sModuller:'',
            sOnayKodlari:'',
            sent: false,
              ContactForm: {
                name : '',
                email: '',
                phone: '',
                subject: 'Bana Ulaşın',
                message: 'Bana Ulaşın'
              }
            }

        },
        computed:{
            ...mapGetters("auth", ["getFirmaResult"])
        },
        methods: {
            gonderMail(){
                //console.log(event);
                //console.log(this.ContactForm);
                //console.log(this);
                //console.log(event);
                //console.log(event.target.childNodes);
                //console.log(event.srcElement.childNodes[1]._value);
                
                event.preventDefault()
                //debugger;
                var str="<?xml version='1.0' encoding='utf-8'?>"+
                      "<soap12:Envelope xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:soap12='http://www.w3.org/2003/05/soap-envelope'>"+
                      "<soap12:Header>" +
                      "<SecuredTokenWebservice xmlns='http://tempuri.org/'>"+
                      "<sMail>"+this.getFirmaResult.sMail+"</sMail>"+
                      "<sUserName>"+this.getFirmaResult.nFirmaID+"</sUserName>"+
                      "<sPassword>"+this.getFirmaResult.sPostaKodu+"</sPassword>"+
                      "<AuthenticationToken>string</AuthenticationToken>"+
                      "<sBayii>"+this.getFirmaResult.nFirmaID+"</sBayii>"+
                      "</SecuredTokenWebservice>"+
                      "</soap12:Header>"+
                      "<soap12:Body>"+
                      "<AuthenticationUser xmlns='http://tempuri.org/' />"+
                      "</soap12:Body>"+
                      "</soap12:Envelope>";
                      
                      axios({method:'post',url:'https://www.barkodyazilimevi.com.tr/AuthToken.asmx',data:str,headers: {'Content-Type': 'text/xml','Access-Control-Allow-Headers': 'Origin'}})
                      .then((response) => {
                        //console.log(response);
                        var parseString = require('xml2js').parseString;
                        var xml = response.data
                        var AuthenticationToken =""
                        parseString(xml, function (err, result) {
                          //console.log(result["soap:Envelope"]["soap:Body"][0].AuthenticationUserResponse[0].AuthenticationUserResult[0]);
                          AuthenticationToken = result["soap:Envelope"]["soap:Body"][0].AuthenticationUserResponse[0].AuthenticationUserResult[0];
                        });
                      var sFirma = "<p><strong><u>" + this.ContactForm.message + ";</u></strong><br>" + "Adım:<strong>" + this.ContactForm.name  + "</strong><br>"+"Mail Adresim:<strong>" + this.ContactForm.email + "</strong></p>";
                      //console.log(sFirma);
                      var ip=window.location.host; 
                      axios('https://api.ipify.org?format=json')
                        .then(response => {
                            ip=response.data.ip
                            console.log(ip);
                        
                      var str2="<?xml version='1.0' encoding='utf-8'?>"+
                      "<soap12:Envelope xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:soap12='http://www.w3.org/2003/05/soap-envelope'>"+
                      "<soap12:Header>" +
                      "<SecuredTokenWebservice xmlns='http://tempuri.org/'>"+
                      "<sMail>"+this.getFirmaResult.sMail+"</sMail>"+
                      "<sUserName>"+this.getFirmaResult.nFirmaID+"</sUserName>"+
                      "<sPassword>"+this.getFirmaResult.sPostaKodu+"</sPassword>"+
                      "<AuthenticationToken>"+AuthenticationToken+"</AuthenticationToken>"+
                      "<sBayii>"+this.getFirmaResult.nFirmaID+"</sBayii>"+
                      "</SecuredTokenWebservice>"+
                      "</soap12:Header>"+
                      "<soap12:Body>"+
                      "<mail_gonder xmlns='http://tempuri.org/'>"+
                      "<sSubject>"+this.ContactForm.subject+"</sSubject>"+
                      "<nFirmaID>"+this.getFirmaResult.nFirmaID+"</nFirmaID>"+
                      "<sKodu></sKodu>"+
                      "<sAciklama></sAciklama>"+
                      "<sAdres1></sAdres1>"+
                      "<sAdres2></sAdres2>"+
                      "<sSemt></sSemt>"+
                      "<sIl></sIl>"+
                      "<telefon></telefon>"+
                      "<sEMail>"+this.ContactForm.email+"</sEMail>"+
                      "<sVergiDairesi></sVergiDairesi>"+
                      "<sVergiNo></sVergiNo>"+
                      "<nAlisverisID>0</nAlisverisID>"+
                      "<lFisNo>0</lFisNo>"+
                      "<sFirma><![CDATA["+  sFirma + "]]></sFirma>"+
                      "<sModuller><![CDATA[<strong>"+this.sModuller+"</strong>]]></sModuller>"+
                      "<sOnayKodlari><![CDATA["+this.sOnayKodlari+"]]></sOnayKodlari>"+
                      "<sOdemeSekli>"+this.ContactForm.subject+"</sOdemeSekli>"+
                      "<sIp>"+ip+"</sIp>"+
                      "</mail_gonder>"+
                      "</soap12:Body>"+
                      "</soap12:Envelope>";
                      
                      //console.log(str2);
                      axios({method:'post',url:'https://www.barkodyazilimevi.com.tr/AuthToken.asmx',data:str2,headers: {'Content-Type': 'text/xml; charset=utf-8','Access-Control-Allow-Headers': 'Origin'}})
                      .then((response) => {
                          if (response.status==200){
                            console.log(response.statusText);
                            notify(this.$t('thanks'), "info", 5000);
                            this.sent=true;
                            this.ContactForm.name="";
                            this.ContactForm.email="";
                          }
                          else{
                                console.log(response); 
                          };
                        
                        event.preventDefault();
                        
                      })
                })
                }
                      );
               
            },
            sendEmail: (e) => {
            e.preventDefault()
            emailjs.sendForm('gmail', 'template_oqDZ37DF', e.target, 'user_eav4bvRheUALfSi9arpIQ')
            .then((result) => {
            console.log('SUCCESS!', result.status, result.text);
            this.ContactForm.name ='',
            this.ContactForm.email=''
            }, (error) => {
            console.log('FAILED...', error);
            
            });
            },
            sendmail() {
                console.log(this.name);
                console.log(this.mail);
                
            },
            sendForm(e) {
               e.preventDefault()
               console.log(this.ContactForm)
            //   axios.post('https://www.barkodyazilimevi.com.tr/mailserver.php',
            //   querystring.stringify(this.ContactForm)).then(res => {
            //     this.sent = true
            //   })

        var config = {
        headers: {'Access-Control-Allow-Origin': '*'}};
                
  //res.header("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");
        axios.post('http://localhost:3000/sendmail',this.ContactForm,config)
        .then((response) => {
          //console.log(response)
          this.msg = response.data
          setTimeout(() => { this.msg = '' }, 10000)
        })
        .catch((error) => {
          console.log(error)
          this.msg = `This is embarassing.  Something seems to have gone wrong. :(
                      Due to the error you can also conact me at toliverpaull@gmail.com.`
        })
            }
        }
    }
</script>